<template>
  <Modal
    name="LINK_ASAAS_CUSTOMER_MODAL"
    :title="$t('customer.label.createLink')"
  >
    <template v-slot:body>
      <FilterSearch
        type="search"
        class="mt-3 mb-0"
        ref="filterCustomers"
        label="searchForAsaasCustomer"
        :fetchData="filters.search ? fetchAsaasCustomers : () => {}"
      />

      <v-progress-linear
        v-if="isLoading"
        class="mt-n3"
        indeterminate
        absolute
      />

      <v-list class="mt-n5 mb-5" two-line>
        <v-list-item
          v-for="customer in asaasCustomers"
          @click="
            setAsaasCustomer(customer.id, customer.name, customer.cpfCnpj)
          "
          :key="customer.id"
        >
          <v-list-item-content>
            <v-list-item-title>
              {{ customer.name }}
            </v-list-item-title>
            <v-list-item-subtitle>
              {{ formatDocument(customer.cpfCnpj) }}
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-list>

      <v-divider class="mt-n2 mb-7" />

      <v-row class="mb-2">
        <v-col cols="2" class="text-center" align-self="center">
          <v-icon
            :color="selectedAsaasCustomer ? 'primary' : 'grey lighten-2'"
            x-large
          >
            mdi-link-variant
          </v-icon>
        </v-col>
        <v-col cols="10">
          <!-- CUSTOMER -->
          <h6 class="text-uppercase grey--text">
            {{ $t('customer.label.selectedCustomer') }}
          </h6>
          <p class="mb-0">{{ customer.customerName }}</p>
          <small class="grey--text">
            {{ customer.customerDocument }}
          </small>
          <!-- /CUSTOMER -->

          <!-- USER -->
          <div v-if="selectedAsaasCustomer">
            <v-divider class="my-5" />
            <h6 class="text-uppercase grey--text">
              {{ $t('customer.label.selectedAsaasCustomer') }}
            </h6>
            <p class="mb-0">{{ selectedAsaasCustomer.name }}</p>
            <small class="grey--text">
              {{ formatDocument(selectedAsaasCustomer.cnpj) }}
            </small>
          </div>
          <!-- /USER -->
        </v-col>
      </v-row>

      <div v-if="selectedAsaasCustomer" class="text-right">
        <v-btn
          @click="createLink"
          :loading="isLoading"
          color="primary"
          elevation="0"
        >
          Vincular conta
        </v-btn>
      </div>
    </template>
  </Modal>
</template>

<script>
import Modal from '@/components/app/Modal'
import FilterSearch from '@/components/filters/FilterSearch'
import { mapGetters, mapActions, mapMutations } from 'vuex'
import { formatDocument } from '@/util/document'

export default {
  name: 'ModalLinkAsaasCustomer',

  props: {
    customer: {
      type: Object,
    },
  },

  components: {
    Modal,
    FilterSearch,
  },

  data() {
    return {
      selectedAsaasCustomer: null,
      formatDocument,
    }
  },

  watch: {
    customer() {
      this.selectedAsaasCustomer = null
    },
  },

  computed: {
    ...mapGetters([
      'filters',
      'isLoading',
      'asaasCustomers',
      'realEstateList',
      'isRealEstateSearching',
    ]),
  },

  methods: {
    ...mapActions(['fetchAsaasCustomers', 'linkAsaasCustomer']),
    ...mapMutations(['setAsaasCustomers']),

    handleCleanFilter() {
      this.$refs.filterCustomers.$children[0].reset()
    },

    setAsaasCustomer(id, name, cnpj) {
      this.handleCleanFilter()
      this.setAsaasCustomers([])
      this.selectedAsaasCustomer = { id, name, cnpj }
    },

    createLink() {
      this.linkAsaasCustomer({
        asaasCustomerId: this.selectedAsaasCustomer.id,
        realEstateId: this.customer.customerId,
      })
    },
  },
}
</script>
